/**
 * Collapsed-section header badge that follows the section's lifecycle (#43):
 *   processing  →  spinner + "Processing…"
 *   openCount>0 →  warning badge "N open"
 *   else        →  success "Done"  (#104: one completion word app-wide)
 *
 * Optional pdfPage prop renders a "View p.N" link alongside (#14 — section-
 * level PDF deep-link).
 */
import { Badge, Spinner, StatusIndicator } from "@cloudscape-design/components";
import { PdfPageLink } from "@/core/ui/PdfPageLink";

export function SectionStatusBadge({
  processing,
  openCount,
  noWorkLabel = "Done",
  reportId,
  pdfPage,
}: {
  processing: boolean;
  openCount: number;
  noWorkLabel?: string;
  reportId?: string;
  pdfPage?: number | null;
}) {
  const pdfChip =
    reportId && typeof pdfPage === "number" ? <PdfPageLink reportId={reportId} page={pdfPage} /> : null;

  if (processing) {
    return (
      <span style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
        <Spinner size="normal" /> AI processing…
        {pdfChip}
      </span>
    );
  }
  return (
    <span style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
      {openCount > 0 ? (
        <Badge color="red">{openCount} open</Badge>
      ) : (
        <StatusIndicator type="success">{noWorkLabel}</StatusIndicator>
      )}
      {pdfChip}
    </span>
  );
}
